export const fieldsType = Object.freeze({
  INPUT: "input",
  SELECT: "select"
});